
























































































































































































































































































































































//import AuthStore from "@/store/modules/AuthStore";
import Vue from "vue";
//import CarreraService from "@/api/CarreraService";
import AuthStore from "@/store/modules/AuthStore";
import CuponEventoService from "@/api/evento/CuponEventoService";
import EncuestaService, {
  GetMisEncuestasByEvento
} from "@/api/encuesta/EncuestaService";
//import moment from "moment";
import EncuestaCard from "./encuesta/EncuestaCard.vue";
import { AxiosError, AxiosResponse } from "axios";
import PrecioCarreraService from "@/api/carrera/detalle/PrecioCarreraService";
import Impersonate from "@/mixins/Impersonate";
import RaceFilterUtils from "@/utils/RaceFilterUtils";
export default Vue.extend({
  props: [
    "dialog",
    "dato",
    "imagen",
    "tallas"
    // "categorias",
    //"precio", ahora el precio va ligado a las distancias
    // "distancias"
  ],
  components: { EncuestaCard },
  mixins: [Impersonate],
  data() {
    return {
      isLoading: false,
      cuponEvento: "",
      // encuestas inicio
      card: {
        src:
          "https://opinionpublica.uvm.mx/sites/default/files/backgrounds/sociales_4.jpg"
      },
      canBuy: false,
      encuestas: {
        aprobadas: [],
        enviadas: [],
        nuevas: [],
        encuestas: [],
        ready: false
      } as GetMisEncuestasByEvento,
      // encuestas fin
      // contarRegistros: -1,
      id: 0,
      distancia: {
        id: 0,
        nombre: "",
        precios: [] as {
          id: number;
          nombre: string;
          precio: number;
          tipoDescriptor: string;
        }[]
      },
      distancias: [] as {
        id: number;
        nombre: string;
      }[],
      categoria: 0,
      talla: 0,
      personalizacion: "",
      TextRules: [(v: string) => !!v || "Campo no debe estar vacio"],
      PersonalizacionRules: [
        (v: string) => v.length <= 10 || "La logintud no debe ser mayor a 10",
        (v: string) =>
          !v || /^[a-z0-9 .#@_-]+$/i.test(v) || "Carácter no permitido"
      ],
      valid: true,
      precio: {
        id: 0,
        precio: 0,
        nombre: ""
      },
      precios: [] as {
        id: number;
        nombre: string;
        precio: number;
        tipoDescriptor: string;
      }[],
      categoriasByD: [] as any[],
      // nuevos campos modelo
      modeloCamiseta: "",
      persona: null,
      datosAdicionales: {} as Record<string, string>
    };
  },
  created() {
    //this.editedItem = { ...this.dato };
  },
  async mounted() {
    //this.selectCategoria();
    await this.contarMisRegistros(this.dato.id);
    this.loadEncuestas();
    this.loadDependants();
  },
  methods: {
    async contarMisRegistros(idRegistro: any) {
      await this.getCountRegistrations(idRegistro);
    },
    /*
    selectCategoria() {
      if (this.categorias.length > 0) {
        this.categoria = this.categorias[0];
      }
    },
    */
    dialogChange(value: boolean) {
      this.$emit("dialogChange", value);
    },
    close() {
      this.restoreUserPerson();
      this.dialogChange(false);
    },
    validate() {
      const isValid = (this.$refs.form as Vue & {
        validate: () => boolean;
      }).validate();
      if (isValid) {
        this.save();
      }
    },
    save() {
      let categoriaDisplay = "";
      for (const v of this.categoriasByD) {
        if (v.id === this.categoria) {
          categoriaDisplay = v.displayCategoria;
        }
      }
      const dto = {
        id: this.dato.id,
        precio: this.precio,
        distancia: this.distancia,
        personalizacion: this.personalizacion,
        talla: this.talla,
        categoria: this.categoria,
        carrera: this.dato,
        imagen: this.imagen,
        displayCategoria: categoriaDisplay,
        cuponEvento: this.cuponEvento,
        persona: this.impersonated,
        datosAdicionales: this.getDatosAdicionalesPayload()
      };
      // validar cupon
      this.isLoading = true;
      if (dto.cuponEvento) {
        CuponEventoService.validar({
          carreraID: dto.carrera.id,
          codigo: dto.cuponEvento,
          distanciaID: dto.distancia.id,
          tallaID: dto.talla.id
        })
          .then((response: AxiosResponse) => {
            this.$swal({
              toast: true,
              position: "bottom-right",
              showConfirmButton: false,
              timer: 2000,
              icon: "success",
              title: "Cupón",
              text: `es válido y se aplicara un ${response?.data?.cupon?.porcentajeDescuento}% de descuento`
            });
            this.dialogChange(false);
            this.$emit("saved", dto);
          })
          .catch((error: AxiosError) => {
            let mensaje = "No se puede utilizar";
            if (error.response?.data && error.response.data.message) {
              mensaje = error.response.data.message;
            }
            this.$swal({
              toast: true,
              position: "bottom-right",
              showConfirmButton: false,
              timer: 3000,
              icon: "error",
              title: "Cupón",
              text: mensaje
            });
          });
      } else {
        this.dialogChange(false);
        this.$emit("saved", dto);
        this.restoreUserPerson();
      }

      this.isLoading = false;
      //this.dialogChange(false);
      //this.$emit("saved", dto);
    },
    onChangePerson() {
      this.switchToPerson(this.impersonated);
      this.distancias = RaceFilterUtils.filterDistances(this.dato.distancias);
      this.precio = { id: 0, precio: 0, nombre: "" };
      this.distancia = null;
      this.talla = null;
    },
    onChangeDistancia() {
      this.precio = { id: 0, precio: 0, nombre: "" };
      this.categoria = 0;
      this.loadPrecios();
      this.loadCategorias();
    },
    onChangeShirtSize() {
      this.precio = { id: 0, precio: 0, nombre: "" };
      this.loadPrecios();
    },
    loadPrecios() {
      this.precios = PrecioCarreraService.filterPricesAndOrderAsc(
        this.distancia?.precios ?? []
      );

      if (this.talla) {
        this.precios = PrecioCarreraService.filterPricesByShirtSize(
          this.precios,
          this.talla
        );
      }

      if (this.precios.length > 0) {
        this.precio = this.precios[0];
      }
    },
    loadCategorias() {
      const baseCategories = RaceFilterUtils.filterCategories(
        this.dato.categorias ?? []
      );
      const categorias = [];
      for (const v of baseCategories) {
        if (v.distanciaId == this.distancia.id) {
          categorias.push(v);
        }
      }
      categorias.sort((a, b) => a.edadMinima - b.edadMinima); // de menor a mayor edad minima
      this.categoriasByD = categorias;
      if (this.categoriasByD.length > 0) {
        this.categoria = this.categoriasByD[0];
      }
    },
    loadEncuestas() {
      if (this.dato.modalidad !== "PCV") {
        this.encuestas.ready = true;
        return;
      }
      EncuestaService.getMisEncuestasByEvento(this.dato.id)
        .then(response => {
          this.encuestas = response;
        })
        .catch(() => {
          this.$swal({
            toast: true,
            position: "center",
            showConfirmButton: false,
            timer: 2000,
            icon: "error",
            title: "Encuestas",
            text: "No se pudo obtener"
          });
        });
    },
    savedForm() {
      this.loadEncuestas();
    },
    onChangeModeloCamiseta() {
      this.talla = 0;
    },
    getCampoAdicionalRules(campo: {
      nombre: string;
      requerido: boolean;
      tipo?: "text" | "select";
      opciones?: string[];
    }) {
      if (!campo.requerido) {
        return [];
      }

      if (campo.tipo === "select") {
        const opciones = Array.isArray(campo.opciones) ? campo.opciones : [];
        return [
          (v: string) => !!(v && String(v).trim()) || "Campo no debe estar vacio",
          (v: string) =>
            !v || opciones.length === 0 || opciones.includes(String(v))
              ? true
              : "Opción inválida"
        ];
      }

      return [
        (v: string) => !!(v && String(v).trim()) || "Campo no debe estar vacio"
      ];
    },
    getDatosAdicionalesPayload() {
      if (!this.requiereCamposAdicionales || this.camposAdicionales.length === 0) {
        return null;
      }
      const payload: Record<string, string> = {};
      for (const campo of this.camposAdicionales) {
        payload[campo.nombre] = this.datosAdicionales[campo.nombre] || "";
      }
      return payload;
    }
  },
  computed: {
    isAdmin() {
      return AuthStore.getLoggedIn && AuthStore.isAdmin;
    },
    modelosCamiseta(): string[] {
      const modelosCamiseta = new Set<string>();
      for (const talla of this.tallas) {
        modelosCamiseta.add(talla.modelo);
      }
      return Array.from(modelosCamiseta);
    },
    tallasCamiseta(): any[] {
      const result = this.tallas.filter(
        (item: any) => item.modelo === this.modeloCamiseta &&
          (
            AuthStore.getPersonaEdad >= item.talla.edadMinima &&
            AuthStore.getPersonaEdad <= item.talla.edadMaxima
          )
      );
      if (result) {
        result.sort(function(a: any, b: any) {
          return a.talla.position - b.talla.position;
        });
        return result;
      } else {
        return [];
      }
    },
    requiereCamposAdicionales(): boolean {
      return !!this.dato?.requiereDatosAdicionales;
    },
    camposAdicionales(): Array<{
      nombre: string;
      requerido: boolean;
      tipo: "text" | "select";
      opciones: string[];
    }> {
      if (!Array.isArray(this.dato?.camposAdicionales)) {
        return [];
      }
      return this.dato.camposAdicionales
        .map((campo: any) => ({
          nombre: String(campo?.nombre || "").trim(),
          requerido: Boolean(campo?.requerido),
          tipo: campo?.tipo === "select" ? "select" : "text",
          opciones: Array.isArray(campo?.opciones)
            ? campo.opciones
                .map((opcion: string) => String(opcion || "").trim())
                .filter((opcion: string) => opcion !== "")
            : []
        }))
        .filter((campo: any) => campo.nombre);
    },
    hasMissingRequiredAdditionalFields(): boolean {
      if (!this.requiereCamposAdicionales) {
        return false;
      }
      for (const campo of this.camposAdicionales) {
        if (!campo.requerido) {
          continue;
        }
        const value = this.datosAdicionales[campo.nombre];
        if (!(value && String(value).trim())) {
          return true;
        }
        if (campo.tipo === "select" && campo.opciones.length > 0) {
          if (!campo.opciones.includes(String(value))) {
            return true;
          }
        }
      }
      return false;
    },
    contarRegistros() {
      return this.countInscriptions[AuthStore.getPersonaID];
    }
  },
  watch: {
    personalizacion(newVal: string) {
      this.personalizacion = newVal.toUpperCase();
    }
  }
  //
});
